import { createContext, useContext } from 'react'

export const WebpSupportedContext = createContext(false)

export const useWebpSupported = () => useContext(WebpSupportedContext)
